import React from 'react'
import { TIconSize } from 'transfix-ui/components/SvgIcon/types'
import { AlertFilledIcon, AlertIcon } from 'transfix-icons'
import { TIconColor } from './types'

interface ISLADueStatusProps {
  isPastSLA: boolean
  isNearSLA: boolean
  color: TIconColor
  iconSize: TIconSize
}

const SLAAlertIcon = ({ color, iconSize, isNearSLA, isPastSLA }: ISLADueStatusProps) => {
  if (isPastSLA) {
    return <AlertFilledIcon color={color} size={iconSize} data-test='past-sla-icon' />
  }
  if (isNearSLA) {
    return <AlertIcon color={color} size={iconSize} data-test='near-sla-icon' />
  }
  return null
}

export default SLAAlertIcon
